/**   
 * api接口统一管理
 */
 import {
    get,
    post
  } from '../request'
//首页数据
  export const indexApi = data => get("/api/index/init", data)
  //列表数据
  export const listApi = poiTypeId => get("/api/index/point?id=2&poiTypeId="+poiTypeId)
  //点位详情数据
  export const pointDetailApi = id => get("/api/index/point/info/"+id)
  //周边数据
  export const roundDetailApi = (id,typeId) => get("/api/index/point/recommend?id="+id+'&typeId='+typeId)
  //天气数据
  export const weatherApi = data => get("/api/index/weather", data)
  //路线数据
  export const routeApi = data => get("/api/index/lines", data)
  //线路详情数据
  export const lineDetailApi = id => get("/api/index/line/info/"+id)
  //搜索数据
  export const searchApi = typeName => get("/api/index/search?word="+typeName)